import React from "react";
import { useTranslation } from "react-i18next";

import { WithTooltip } from "../WithTooltip/WithTooltip";

export const CompanyNameLabel = () => {
  const { t } = useTranslation();
  return <WithTooltip tooltipMessage={t("tooltips.legalFormTooltip")}>{t("invoiceDetails.companyName")}</WithTooltip>;
};
